#import "../fragments/landing-page-full-fragment.graphql"

mutation PublishPage($input: PagePublishInput!) {
    pagePublish(input: $input) {
        page {
            ...LandingPageFullFragment
        }
    }
}
